var map = {
	"./arrows_curve_left_blue.png": 614,
	"./arrows_curve_left_grey.png": 2089,
	"./arrows_curve_left_red.png": 3868,
	"./arrows_curve_right_blue.png": 2693,
	"./arrows_curve_right_grey.png": 636,
	"./arrows_curve_right_red.png": 8754,
	"./arrows_map_bachmut.png": 778,
	"./arrows_map_northeast.png": 2163,
	"./arrows_straight_blue.png": 451,
	"./arrows_straight_grey.png": 1216,
	"./arrows_straight_red.png": 714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5665;